<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>
<div class="modal-signup modal-content" *ngIf="ModalName=='oldmodal'">

  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Add Cycle Activity

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-left-0px padding-top-5px">


        <div class="modal-body padding-top-0px  padding-right-0px padding-bottom-0px">

          <div class="row">
            <div class="col-md-3 padding-right-0px bk-color-light2">
              <div class="row margin-top-10" *ngIf="PlanDetails">
                <div class="col-md-12 text-align-center padding-left-0px">
                  <img class="img-circle-50" [src]="PlanDetails.OwnerPatientImageFile" onError="this.src='dummy.jpg';">
                </div>
              </div>
              <div class="row" *ngIf="PlanDetails">
                <div class="col-md-12 text-align-center padding-left-0px">
                  <label class="margin-bottom-0px font-size-16px color-Assign">{{PlanDetails.OwnerName}}</label>
                </div>
              </div>
              <div class="row" *ngIf="PlanDetails">
                <div class="col-md-12 text-align-center padding-left-0px line-height-10px">
                  <!--<label class="margin-bottom-0px">{{PlanDetails.OwnerGender}},{{PlanDetails.OwnerAgeYears}}Years</label>-->
                  <div [ngSwitch]="PlanDetails.OwnerGender">
                    <div *ngSwitchCase="'F'" class="font-size-12px">
                      <!--<label class="margin-left-3 margin-bottom-0px "> Female</label>-->
                      Female,{{PlanDetails.OwnerAgeYears}}
                    </div>
                    <div *ngSwitchCase="'M'" class="font-size-12px">
                      <!--<label class="margin-left-3 margin-bottom-0px label-table-color"> {{l.StartDate| date:'MMM-dd-yyyy'}}</label>-->
                      Male,{{PlanDetails.OwnerAgeYears}}
                    </div>


                    <div *ngSwitchCase="'O'" class="td-brorder-8px-blue font-size-12px">
                      <!--<label class="margin-left-3 margin-bottom-0px label-table-color margin-bottom-0px"> {{l.StartDate| date:'MMM-dd-yyyy'}}</label>-->
                      Other,{{l.PlanDetails.OwnerAgeYears}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="PlanDetails">
                <div class="col-md-12  text-align-center padding-left-0px line-height-17px">
                  <label class="margin-bottom-0px">{{PlanDetails.OwnerFormattedCode}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px" *ngIf="PlanDetails">
                <div class="col-md-12 padding-right-4px padding-left-0px">
                  <div class="card card-background-transparent border-all-1px border-radius-5px">
                    <div class="card-body padding-all-0px margin-left-0px">
                      <div class="row margin-left-0px" *ngIf="PlanDetails">
                        <div class="col-md-5 text-align-right padding-left-0px">
                          <label class="margin-bottom-0px font-size-12px">Cycle Type</label>
                        </div>:
                        <div class="col-md-5">
                          <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{PlanDetails.CycleType}}</label>
                        </div>
                      </div>
                      <div class="row margin-left-0px" *ngIf="PlanDetails">
                        <div class="col-md-5 text-align-right">
                          <label class="margin-bottom-0px font-size-12px">Treatment</label>
                        </div>:
                        <div class="col-md-6">
                          <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{PlanDetails.ProtocolName}}</label>
                        </div>
                      </div>
                      <div class="row margin-left-0px" *ngIf="PlanDetails">
                        <div class="col-md-5 text-align-right">
                          <label class="margin-bottom-0px font-size-12px">LMP</label>
                        </div>:
                        <div class="col-md-6 padding-right-0px">
                          <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{PlanDetails.LMP| date:'MMM-dd-yyyy'}}</label>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </div>
              <div class="row margin-right-0px margin-top-5px" hidden>
                <div class="Dsa1 margin-left-auto">
                  <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14" *ngIf="Doc1">{{Doc1}}</label>
                </div>
                <div class="Dsa2">
                  <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14" *ngIf="Stimulation">{{Stimulation}}</label>
                </div>
                <div class="Dsa3 margin-right-auto">

                  <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14" *ngIf="Antag">{{Antag}}</label>
                </div>

              </div>
              <!--<div class="row margin-left-0px margin-right-0px margin-top-10">
                <div class="col-md-12 padding-right-4px padding-left-0px">
                  <div class="card card-background-transparent border-all-1px border-radius-5px">
                    <div class="card-header padding-all-0px font-size-13px card-background-transparent text-align-center">
                      DOC
                    </div>
                    <div class="card-body padding-all-0px margin-left-0px">
                      <div class="row margin-left-0px">

                        <div class="col-md-12 padding-left-0px text-align-center">
                          <h4 class="margin-bottom-0px margin-top-3px color-Assign font-size-18px">{{Doc}}</h4>
                        </div>
                      </div>

                    </div>

                  </div>
                </div>

              </div>-->
              <!--<div class="row" *ngIf="PlanDetails">
                <div class="col-md-12  text-align-center padding-left-0px line-height-17px">
                  <label class="margin-bottom-0px">{{PlanDetails.ProtocolName}}</label>
                </div>
              </div>
              <div class="row padding-top-5px" *ngIf="PlanDetails">
                <div class="col-md-12  text-align-center padding-left-0px line-height-17px">
                  <label class="margin-bottom-0px">{{PlanDetails.CycleType}}</label>
                </div>
              </div>
              <div class="row" *ngIf="PlanDetails">
                <div class="col-md-12  text-align-center padding-left-0px line-height-17px">
                  <label class="margin-bottom-0px">LMP: {{PlanDetails.LMP| date:'MMM-dd-yyyy'}}</label>
                </div>
              </div>-->
              <!--<div class="row margin-top-5px">
                <div class="badge chatbox-new-doc margin-right-10px margin-bottom-10px col-md-12 padding-left-10pe padding-right-19pe">
                  <div>
                    <label class="margin-bottom-0px">DOC</label>

                  </div>
                  <div class="margin-top-10 border-top-light2">
                    <h4 class="margin-top-10 font-size-16px font-weight-bold color-Assign">5</h4>

                  </div>
                </div>
              </div>-->
            </div>
            <div class="col-md-9 padding-left-0px">
              <ul class="nav nav-tabs nav-tab-cycle padding-all-10px " id="tabContent">

                <li class="active col text-align-center border-right-4px"><a class="nav-item4 active" href="#Test" data-toggle="tab">Test</a></li>
                <li class="col text-align-center border-right-4px"><a class="nav-item4" href="#Medicine" data-toggle="tab">Medicine</a></li>
                <li class="col text-align-center"><a class="nav-item4" href="#Activity" data-toggle="tab">Other</a></li>

              </ul>

              <div class="tab-content">
                <div class="tab-pane active" id="Test">
                  <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
                    <div class="card margin-top-10">
                      <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-top-0px padding-bottom-0px">
                        <div class="row margin-left-auto">
                          <div class="col-md-7 padding-right-0px border-right-3px-test">
                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right padding-left-0px">
                                    <label for="firstName" class="margin-bottom-0px margin-top-5px"><span>*</span>Activity For</label>
                                  </div>
                                  <div class="col-md-5">
                                    <CodeTypeValue CodeType="IVFRC" (ngModelChange)="onChange2($event)" id="CurrentSaveTestMedCycleActivitiesRequest.ActivityType"
                                                   [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" SelectedValue=""
                                                   name="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" required #Activity="ngModel">

                                    </CodeTypeValue>
                                    <!--<CodeTypeValue CodeType="IVFAC" id="CurrentSaveTestMedCycleActivitiesRequest.ActivityType"
                                                   [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" SelectedValue=""
                                                   name="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" required>
                                    </CodeTypeValue>-->
                                    <!--<input type="text" class="form-control" placeholder="Test"
                                           id="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                           [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                           name="CurrentSaveIvfCycleMedicineDataRequest.Form" #Doctor="ngModel"
                                           maxlength="100" required>
                                    <small class="form-text text-danger"
                                           *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                    <small class="form-text text-danger"
                                           *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->
                                    <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                                                             id="CurrentSaveIvfCycleMedicineDataRequest.Form" SelectedValue=""
                                                             [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form" (keyChange)="onAssignedToActorCode($event)"
                                                             name="CurrentSaveIvfCycleMedicineDataRequest.Form" required>
                                    </CustomDataByRequestType>-->
                                  </div>

                                </div>

                              </div>
                            </div>
                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right padding-left-0px">
                                    <label for="firstName" class="margin-bottom-0px margin-top-5px"><span>*</span>Day(&amp; Date)</label>
                                  </div>
                                  <div class="col-md-4">
                                    <select class="form-control" (change)="onChange($event.target.value)">
                                      <option selected="selected" value=""></option>
                                      <option *ngFor="let l of CurrentDSAActivityByCycleCodeController">
                                        {{l.DSA}}
                                      </option>
                                    </select>

                                  </div>
                                  <div class="col-md-4 padding-left-0px" *ngIf="ActivityDate">

                                    <label class="margin-bottom-0px margin-top-7px"> ({{ActivityDate | date:'MMM-dd-yyyy'}})</label>
                                  </div>
                                </div>

                              </div>
                            </div>
                            <!--<div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                                <div class="row">
                                  <div class="col-md-3 text-align-right margin-tg-auto ">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Date</label>
                                  </div>


                                  <div class="col-md-4" *ngIf="ActivityDate">

                                    <label class="margin-bottom-0px margin-top-3px"> {{ActivityDate | date:'MMM-dd-yyyy'}}</label>
                                  </div>


                                </div>


                              </div>
                            </div>-->
                            <!--<div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                <div class="row">
                                  <div class="col-md-3 text-align-right">
                                    <label for="firstName" class="margin-bottom-0px margin-top-5px"><span>*</span>Test Name</label>
                                  </div>
                                  <div class="col-md-5 padding-right-8px">



                                    <CustomDataByRequestType RequestedType="IvfFolScanDayTests" ActorCode={{ActorCode}} (keyChange)="onAssignedToActorCode($event)"
                                                             id="CurrentSaveTestMedCycleActivitiesRequest.TestCode" SelectedValue=""
                                                             [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.TestCode"
                                                             name="CurrentSaveTestMedCycleActivitiesRequest.TestCode" required #Test="ngModel">
                                    </CustomDataByRequestType>

                                  </div>

                                </div>

                              </div>
                            </div>-->

                            <div class="row margin-top-3px">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right ">
                                    <label for="diaplayName">Comments </label>
                                  </div>
                                  <div class="col-md-6 padding-right-8px ">
                                    <!--<CodeTypeValue CodeType="MARTL"></CodeTypeValue>-->

                                    <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Comments"
                                              name="CurrentSaveTestMedCycleActivitiesRequest.Remarks"
                                              [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.Remarks" required minlength="1" maxlength="100"
                                              #addconcerns_text="ngModel"></textarea>
                                    <small class="form-text text-danger"
                                           *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>
                                  </div>
                                </div>


                              </div>
                            </div>




                          </div>
                          <div class="col-md-5">
                            <div class="card">
                              <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px  padding-t-6px padding-left-8px padding-right-0px font-size-16px">
                                <div class="row">
                                  <div class="col-md-12">
                                    Select Tests
                                  </div>

                                </div>
                                <div class="row margin-top-5px margin-bottom-10px margin-left-0px">
                                  <div class="col-md-10 padding-left-0px">
                                    <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>

                                  </div>



                                </div>
                              </div>
                              <div class="card-body padding-top-0px padding-left-0px padding-right-0px padding-bottom-0px margin-left-0px">

                                <div class="chatsd product-chart-wrapper product-chat-height-200px agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                                  <div class="table-component actor-table margin-bottom-0px">

                                    <div class="table-responsive overflow-x-hidden overflow-y-hidden">


                                      <table class="table table-striped table2">
                                        <tbody>
                                          <tr *ngFor="let l of pdata">
                                            <td class="td-padding-2px">

                                              <div class="row margin-left-zero margin-right">
                                                <div class="col-md-2  margin-tb-auto padding-right-0px padding-left-0px">
                                                  <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                                         [(ngModel)]="l.IsSelected" name="check">
                                                  <i class="input-helper"></i>

                                                </div>
                                                <div class="col-md-10 margin-tb-auto padding-left-0px">
                                                  <label class="margin-bottom-0px color3 font-size-12px">{{l.DisplayName}}</label>

                                                </div>
                                              </div>


                                            </td>
                                          </tr>

                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>




                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="card-footer text-align-center padding-top-10 padding-bottom-10px">
                        <button type="submit" [disabled]="Activity.errors?.required" class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>
                        <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto float-right margin-right-10px" (click)="activeModal.close('Close click')">Close</button>

                      </div>
                    </div>
                  </form>
                </div>

                <div class="tab-pane" id="Medicine">
                  <form class="form " novalidate="" (ngSubmit)="onSubmitMedicine()" #f="ngForm">
                    <div class="card">
                      <div class="card-body padding-bottom-0px">
                        <div class="row margin-left-auto">
                          <div class="col-md-7 padding-l-0px">
                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-5 text-align-right">
                                    <label for="firstName" class="margin-bottom-0px margin-top-5px"><span>*</span>Medicine Name</label>
                                  </div>
                                  <div class="col-md-7">

                                    <!--<CodeTypeValue CodeType="MARTL"
                                    id="CurrentSaveIvfCycleMedicineDataRequest.MedicineName"
                                    [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.MedicineName" SelectedValue=""
                                    name="CurrentSaveIvfCycleMedicineDataRequest.MedicineName" required></CodeTypeValue>-->
                                    <!--<input type="text" class="form-control" placeholder="Test"
                                           id="CurrentSaveIvfCycleMedicineDataRequest.MedicineName"
                                           [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.MedicineName"
                                           name="CurrentSaveIvfCycleMedicineDataRequest.MedicineName" #Doctor="ngModel"
                                           maxlength="100" required>
                                    <small class="form-text text-danger"
                                           *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                    <small class="form-text text-danger"
                                           *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->
                                    <CustomDataByRequestType RequestedType="IvfFolScanDayMeds" ActorCode={{ActorCode}} (keyChange)="onAssignedToActorCode2($event)"
                                                             id="CurrentSaveTestMedCycleActivitiesRequest.MedicineCode" SelectedValue=""
                                                             [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.MedicineCode"
                                                             name="CurrentSaveTestMedCycleActivitiesRequest.MedicineCode" required #MedicineName="ngModel">
                                    </CustomDataByRequestType>

                                  </div>

                                </div>

                              </div>
                            </div>
                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-5 text-align-right padding-left-0px">
                                    <label for="firstName" class="margin-bottom-0px margin-top-5px"><span>*</span>Activity For</label>
                                  </div>
                                  <div class="col-md-7">

                                    <CodeTypeValue CodeType="IVFRC" (ngModelChange)="onChange2($event)" id="CurrentSaveTestMedCycleActivitiesRequest.ActivityType"
                                                   [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" SelectedValue=""
                                                   name="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" required #ActivityFor="ngModel">

                                    </CodeTypeValue>
                                    <!--<input type="text" class="form-control" placeholder="Test"
                                           id="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                           [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                           name="CurrentSaveIvfCycleMedicineDataRequest.Form" #Doctor="ngModel"
                                           maxlength="100" required>
                                    <small class="form-text text-danger"
                                           *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                    <small class="form-text text-danger"
                                           *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->
                                    <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                                                             id="CurrentSaveIvfCycleMedicineDataRequest.Form" SelectedValue=""
                                                             [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form" (keyChange)="onAssignedToActorCode($event)"
                                                             name="CurrentSaveIvfCycleMedicineDataRequest.Form" required>
                                    </CustomDataByRequestType>-->
                                  </div>



                                </div>

                              </div>
                            </div>
                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-5 text-align-right padding-left-0px">
                                    <label for="firstName" class="margin-bottom-0px margin-top-5px"><span>*</span>Day(&amp; Date)</label>
                                  </div>
                                  <div class="col-md-4 padding-right-0px">
                                    <select class="form-control" (change)="onChange($event.target.value)">
                                      <option selected="selected" value=""></option>
                                      <option *ngFor="let l of CurrentDSAActivityByCycleCodeController">
                                        {{l.DSA}}
                                      </option>
                                    </select>

                                  </div>
                                  <div class="col-md-3 padding-left-0px padding-right-0px" *ngIf="ActivityDate">

                                    <label class="margin-bottom-0px margin-top-3px"> ({{ActivityDate | date:'MMM-dd-yyyy'}})</label>
                                  </div>
                                </div>

                              </div>
                            </div>





                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-5 text-align-right">
                                    <label for="firstName" class="margin-bottom-0px margin-top-5px"><span>*</span>Route</label>
                                  </div>
                                  <div class="col-md-7" *ngIf="TCModelName!=='Fet'">

                                    <CodeTypeValue CodeType="IVFDF"
                                                   id="CurrentSaveTestMedCycleActivitiesRequest.Form"
                                                   [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.Form" SelectedValue=""
                                                   name="CurrentSaveTestMedCycleActivitiesRequest.Form" required>
                                    </CodeTypeValue>
                                    <!--<input type="text" class="form-control" placeholder="Test"
           id="CurrentSaveIvfCycleMedicineDataRequest.Form"
           [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form"
           name="CurrentSaveIvfCycleMedicineDataRequest.Form" #Doctor="ngModel"
           maxlength="100" required>
    <small class="form-text text-danger"
           *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
    <small class="form-text text-danger"
           *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->
                                    <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                             id="CurrentSaveIvfCycleMedicineDataRequest.Form" SelectedValue=""
                             [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form" (keyChange)="onAssignedToActorCode($event)"
                             name="CurrentSaveIvfCycleMedicineDataRequest.Form" required>
    </CustomDataByRequestType>-->
                                  </div>

                                  <div class="col-md-7" *ngIf="TCModelName=='Fet'">

                                    <CodeTypeValue CodeType="FETDF"
                                                   id="CurrentSaveTestMedCycleActivitiesRequest.Form"
                                                   [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.Form" SelectedValue=""
                                                   name="CurrentSaveTestMedCycleActivitiesRequest.Form" required>
                                    </CodeTypeValue>
                                    
                                  </div>

                                </div>

                              </div>
                            </div>
                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                <div class="row">
                                  <div class="col-md-5 text-align-right">
                                    <label for="firstName" class="margin-bottom-0px margin-top-5px"><span>*</span>Dose</label>
                                  </div>
                                  <div class="col-md-3 padding-right-0px">

                                    <!--<input type="number" class="form-control" placeholder="Dose"
                                           id="CurrentSaveTestMedCycleActivitiesRequest.Dose"
                                           [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.Dose" required
                                           name="CurrentSaveTestMedCycleActivitiesRequest.Dose" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                           maxlength="100" />
                                    <small class="form-text text-danger"
                                           *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(special characters are not allowed)</small>-->
                                    <input type="text" class="form-control" placeholder="Dose"
                                           id="CurrentSaveTestMedCycleActivitiesRequest.Dose"
                                           [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.Dose" required
                                           name="CurrentSaveTestMedCycleActivitiesRequest.Dose" pattern="^[\0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                           maxlength="5">
                                    <small class="form-text text-danger"
                                           *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(only numbers are allowed)</small>
                                    <!--<input type="text" class="form-control" placeholder="Dose"
                                           id="CurrentSaveIvfCycleMedicineDataRequest.Dose"
                                           [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Dose"
                                           name="CurrentSaveIvfCycleMedicineDataRequest.Dose" pattern="^[\0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                           maxlength="5">
                                    <small class="form-text text-danger"
                                           *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(only numbers are allowed)</small>-->


                                  </div>
                                  <div class="col-md-3 padding-right-0px">
                                    <CodeTypeValue CodeType="IVFDU"
                                                   id="CurrentSaveTestMedCycleActivitiesRequest.DurationType"
                                                   [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.DurationType" SelectedValue=""
                                                   name="CurrentSaveTestMedCycleActivitiesRequest.DurationType" required #Doseunits="ngModel">
                                    </CodeTypeValue>



                                  </div>

                                </div>

                              </div>
                            </div>


                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-5 text-align-right padding-left-0px">
                                    <label for="diaplayName">Instructions </label>
                                  </div>
                                  <div class="col-md-7 ">
                                    <!--<CodeTypeValue CodeType="MARTL"></CodeTypeValue>-->

                                    <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Instructions"
                                              name="CurrentSaveTestMedCycleActivitiesRequest.Instructions"
                                              [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.Instructions" required minlength="1" maxlength="100"
                                              #addconcerns_text="ngModel"></textarea>
                                    <small class="form-text text-danger"
                                           *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>
                                  </div>
                                </div>


                              </div>
                            </div>






                          </div>
                          <div class="col-md-5">
                            <div class="row border-all-1px margin-left-0px margin-right-0px">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-5 text-align-right padding-left-0px">
                                    <label for="firstName" class="margin-bottom-0px margin-top-5px">Purpose</label>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-9" *ngIf="TCModelName!=='Fet'">

                                    <CodeTypeValue CodeType="MDPUR" id="CurrentSaveTestMedCycleActivitiesRequest.Objective"
                                                   [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.Objective" SelectedValue=""
                                                   name="CurrentSaveTestMedCycleActivitiesRequest.Objective" required>

                                    </CodeTypeValue>
                                    <!--<input type="text" class="form-control" placeholder="Test"
           id="CurrentSaveIvfCycleMedicineDataRequest.Form"
           [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form"
           name="CurrentSaveIvfCycleMedicineDataRequest.Form" #Doctor="ngModel"
           maxlength="100" required>
    <small class="form-text text-danger"
           *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
    <small class="form-text text-danger"
           *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->
                                    <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                             id="CurrentSaveIvfCycleMedicineDataRequest.Form" SelectedValue=""
                             [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form" (keyChange)="onAssignedToActorCode($event)"
                             name="CurrentSaveIvfCycleMedicineDataRequest.Form" required>
    </CustomDataByRequestType>-->
                                  </div>

                                  <div class="col-md-9" *ngIf="TCModelName=='Fet'">

                                    <CodeTypeValue CodeType="FETMD" id="CurrentSaveTestMedCycleActivitiesRequest.Objective"
                                                   [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.Objective" SelectedValue=""
                                                   name="CurrentSaveTestMedCycleActivitiesRequest.Objective" required>

                                    </CodeTypeValue>
                                    
                                  </div>

                                </div>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="card-footer text-align-center padding-top-10 padding-bottom-10px">
                        <button type="submit" [disabled]="ActivityFor.errors?.required|| MedicineName.errors?.required|| RecommendedPackage.errors?.required||Doseunits.errors?.required" class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>
                        <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto float-right margin-right-10px" (click)="activeModal.close('Close click')">Close</button>

                      </div>
                    </div>
                  </form>
                </div>

                <div class="tab-pane" id="Activity">
                  <form class="form " novalidate="" (ngSubmit)="onSubmitGeneral()" #f="ngForm">
                    <div class="card">
                      <div class="card-body padding-bottom-0px margin-left-0px padding-left-0px">
                        <div class="row margin-left-auto">
                          <div class="col-md-12 padding-l-0px">
                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right margin-tg-auto ">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Date</label>
                                  </div>


                                  <div class="col-md-4">
                                    <div class="date-form">
                                      <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                                             name="dp" [(ngModel)]="ScheduleGeneralDate" ngbDatepicker #ds="ngbDatepicker" #Date="ngModel" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Date.valid && (Date.dirty || Date.touched) && Date.errors.required)">(Field cannot be left blank)</small>

                                      <a (click)="ds.toggle()" class="nav-link-hand">
                                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                      </a>

                                    </div>
                                  </div>

                                </div>


                              </div>
                            </div>
                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 padding-left-0px text-align-right">
                                    <label for="firstName" class="margin-bottom-0px margin-top-5px">Activity For</label>
                                  </div>
                                  <div class="col-md-4">

                                    <CodeTypeValue CodeType="IVFRC" id="CurrentSaveTestMedCycleActivitiesRequest.ActivityType"
                                                   [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" SelectedValue=""
                                                   name="CurrentSaveTestMedCycleActivitiesRequest.ActivityType">

                                    </CodeTypeValue>
                                    <!--<input type="text" class="form-control" placeholder="Test"
                                           id="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                           [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                           name="CurrentSaveIvfCycleMedicineDataRequest.Form" #Doctor="ngModel"
                                           maxlength="100" required>
                                    <small class="form-text text-danger"
                                           *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                    <small class="form-text text-danger"
                                           *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->
                                    <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                                                             id="CurrentSaveIvfCycleMedicineDataRequest.Form" SelectedValue=""
                                                             [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form" (keyChange)="onAssignedToActorCode($event)"
                                                             name="CurrentSaveIvfCycleMedicineDataRequest.Form" required>
                                    </CustomDataByRequestType>-->
                                  </div>

                                </div>

                              </div>
                            </div>
                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 padding-left-0px text-align-right">
                                    <label for="diaplayName" class="margin-bottom-0px margin-top-8px">Select Activity</label>
                                  </div>

                                  <div class="col-md-4">
                                    <!--<input type="text" class="form-control" placeholder="DOC"
                                           id="CurrentSaveTestMedCycleActivitiesRequest.SelectedActivity"
                                           [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.SelectedActivity" required
                                           name="CurrentSaveTestMedCycleActivitiesRequest.SelectedActivity" pattern="^[\sa-zA-Z0-9,._\-?]*$" #SelectActivity="ngModel"
                                           maxlength="100" />-->
                                    <label *ngIf="User">{{User}}</label>
                                    <!--<CodeTypeValue CodeType="FWUM"></CodeTypeValue>-->
                                    <!--id="CurrentSaveCounsellingActivityRequest.FollowupMode"
                                    [(ngModel)]="CurrentSaveCounsellingActivityRequest.FollowupMode" SelectedValue=""
                                    name="CurrentSaveCounsellingActivityRequest.FollowupMode" required>-->



                                  </div>
                                  <div class="col-md-2 padding-left-0px margin-top-5px">
                                    <!--<div class="thick-circle4 nav-link-hand">
                                      <a>
                                        <i class="fas fa-ellipsis-h"></i>
                                      </a>
                                    </div>-->
                                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3" (click)="Activity()"> <i class="fas fa-ellipsis-h"></i></button>
                                  </div>
                                </div>


                              </div>
                            </div>
                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 padding-left-0px text-align-right">
                                    <label for="diaplayName" class="margin-bottom-0px margin-top-8px">Schedule Date</label>
                                  </div>

                                  <div class="col-md-4">
                                    <div class="date-form">
                                      <input class="form-control" placeholder="Start Date"
                                             name="dp" [(ngModel)]="ScheduleDate2" ngbDatepicker #d="ngbDatepicker" #DateOfBirth="ngModel">
                                      <small class="form-text text-danger"
                                             *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                                      <a (click)="d.toggle()" class="nav-link-hand">
                                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>


                                      </a>

                                    </div>



                                  </div>
                                </div>


                              </div>
                            </div>

                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 padding-left-0px text-align-right">
                                    <label for="diaplayName" class="margin-bottom-0px margin-top-8px">Schedule Time</label>
                                  </div>

                                  <div class="col-md-4">
                                    <input type="time" class="form-control" id="CurrentSaveTestMedCycleActivitiesRequest.ScheduleTime" placeholder="Schedule Time"
                                           [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.ScheduleTime"
                                           name="CurrentSaveTestMedCycleActivitiesRequest.ScheduleTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" />


                                  </div>
                                </div>


                              </div>
                            </div>
                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 padding-left-0px text-align-right padding-left-0px">
                                    <label for="diaplayName" class="margin-bottom-0px margin-top-8px"><span>*</span>Follow-up Mode</label>
                                  </div>

                                  <div class="col-md-4">
                                    <CodeTypeValue CodeType="FWUM"
                                                   id="CurrentSaveTestMedCycleActivitiesRequest.FollowupMode"
                                                   [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.FollowupMode" SelectedValue=""
                                                   name="CurrentSaveTestMedCycleActivitiesRequest.FollowupMode" required #Followup="ngModel">
                                    </CodeTypeValue>


                                  </div>
                                </div>


                              </div>
                            </div>
                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 padding-left-0px text-align-right">
                                    <label for="diaplayName" class="margin-bottom-0px margin-top-8px"><span>*</span>Comments</label>
                                  </div>

                                  <div class="col-md-7 padding-right-0px">
                                    <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Concerns"
                                              name="CurrentSaveTestMedCycleActivitiesRequest.Remarks"
                                              [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.Remarks" required minlength="1" maxlength="100"
                                              #addconcerns_text="ngModel"></textarea>
                                    <small class="form-text text-danger"
                                           *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>


                                  </div>
                                </div>


                              </div>
                            </div>


                          </div>
                        </div>
                      </div>
                      <div class="card-footer text-align-center padding-top-10 padding-bottom-10px">
                        <button type="submit" [disabled]="Date.errors?.required || addconcerns_text.errors?.required|| Followup.errors?.required" class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>
                        <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto float-right margin-right-10px" (click)="activeModal.close('Close click')">Close</button>

                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>











          <!--<div class="card-footer text-align-center">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto" (click)="activeModal.close('Close click')">Close</button>
          </div>-->


















        </div>
        <!--<div class="modal-footer">
          <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
          <button type="submit" [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>
        </div>-->

      </div>
    </div>
  </div>
</div>
<div class="modal-signup modal-content" *ngIf="ModalName=='newmodal'">

  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Add Follicular Scan

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-left-0px padding-top-5px">


        <div class="modal-body padding-top-0px  padding-right-0px padding-bottom-0px">

          <div class="row">
            <div class="col-md-3 padding-right-0px bk-color-light2 padding-bottom-10px">
              <div class="row margin-top-10" *ngIf="PlanDetails">
                <div class="col-md-12 text-align-center padding-left-0px">
                  <img class="img-circle-50" [src]="PlanDetails.OwnerPatientImageFile" onError="this.src='dummy.jpg';">
                </div>
              </div>
              <div class="row" *ngIf="PlanDetails">
                <div class="col-md-12 text-align-center padding-left-0px">
                  <label class="margin-bottom-0px font-size-16px color-Assign">{{PlanDetails.OwnerName}}</label>
                </div>
              </div>
              <div class="row" *ngIf="PlanDetails">
                <div class="col-md-12 text-align-center padding-left-0px line-height-10px">
                  <!--<label class="margin-bottom-0px">{{PlanDetails.OwnerGender}},{{PlanDetails.OwnerAgeYears}}Years</label>-->
                  <div [ngSwitch]="PlanDetails.OwnerGender">
                    <div *ngSwitchCase="'F'" class="font-size-12px">
                      <!--<label class="margin-left-3 margin-bottom-0px "> Female</label>-->
                      Female,{{PlanDetails.OwnerAgeYears}}
                    </div>
                    <div *ngSwitchCase="'M'" class="font-size-12px">
                      <!--<label class="margin-left-3 margin-bottom-0px label-table-color"> {{l.StartDate| date:'MMM-dd-yyyy'}}</label>-->
                      Male,{{PlanDetails.OwnerAgeYears}}
                    </div>


                    <div *ngSwitchCase="'O'" class="td-brorder-8px-blue font-size-12px">
                      <!--<label class="margin-left-3 margin-bottom-0px label-table-color margin-bottom-0px"> {{l.StartDate| date:'MMM-dd-yyyy'}}</label>-->
                      Other,{{l.PlanDetails.OwnerAgeYears}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="PlanDetails">
                <div class="col-md-12  text-align-center padding-left-0px line-height-17px">
                  <label class="margin-bottom-0px">{{PlanDetails.OwnerFormattedCode}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px" *ngIf="PlanDetails">
                <div class="col-md-12 padding-right-4px padding-left-0px">
                  <div class="card card-background-transparent border-all-1px border-radius-5px">
                    <div class="card-body padding-all-0px margin-left-0px">
                      <div class="row margin-left-0px" *ngIf="PlanDetails">
                        <div class="col-md-5 text-align-right padding-left-0px">
                          <label class="margin-bottom-0px font-size-12px">Cycle Type</label>
                        </div>:
                        <div class="col-md-5">
                          <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{PlanDetails.CycleType}}</label>
                        </div>
                      </div>
                      <div class="row margin-left-0px" *ngIf="PlanDetails">
                        <div class="col-md-5 text-align-right">
                          <label class="margin-bottom-0px font-size-12px">Treatment</label>
                        </div>:
                        <div class="col-md-6">
                          <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{PlanDetails.ProtocolName}}</label>
                        </div>
                      </div>
                      <div class="row margin-left-0px" *ngIf="PlanDetails">
                        <div class="col-md-5 text-align-right">
                          <label class="margin-bottom-0px font-size-12px">LMP</label>
                        </div>:
                        <div class="col-md-6 padding-right-0px">
                          <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{PlanDetails.LMP| date:'MMM-dd-yyyy'}}</label>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </div>
              <div class="row margin-right-0px margin-top-5px" hidden>
                <div class="Dsa1 margin-left-auto">
                  <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14" *ngIf="Doc1">{{Doc1}}</label>
                </div>
                <div class="Dsa2">
                  <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14" *ngIf="Stimulation">{{Stimulation}}</label>
                </div>
                <div class="Dsa3 margin-right-auto">

                  <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14" *ngIf="Antag">{{Antag}}</label>
                </div>

              </div>
              <!--<div class="row margin-left-0px margin-right-0px margin-top-10">
                <div class="col-md-12 padding-right-4px padding-left-0px">
                  <div class="card card-background-transparent border-all-1px border-radius-5px">
                    <div class="card-header padding-all-0px font-size-13px card-background-transparent text-align-center">
                      DOC
                    </div>
                    <div class="card-body padding-all-0px margin-left-0px">
                      <div class="row margin-left-0px">

                        <div class="col-md-12 padding-left-0px text-align-center">
                          <h4 class="margin-bottom-0px margin-top-3px color-Assign font-size-18px">{{Doc}}</h4>
                        </div>
                      </div>

                    </div>

                  </div>
                </div>

              </div>-->
              <!--<div class="row" *ngIf="PlanDetails">
                <div class="col-md-12  text-align-center padding-left-0px line-height-17px">
                  <label class="margin-bottom-0px">{{PlanDetails.ProtocolName}}</label>
                </div>
              </div>
              <div class="row padding-top-5px" *ngIf="PlanDetails">
                <div class="col-md-12  text-align-center padding-left-0px line-height-17px">
                  <label class="margin-bottom-0px">{{PlanDetails.CycleType}}</label>
                </div>
              </div>
              <div class="row" *ngIf="PlanDetails">
                <div class="col-md-12  text-align-center padding-left-0px line-height-17px">
                  <label class="margin-bottom-0px">LMP: {{PlanDetails.LMP| date:'MMM-dd-yyyy'}}</label>
                </div>
              </div>-->
              <!--<div class="row margin-top-5px">
                <div class="badge chatbox-new-doc margin-right-10px margin-bottom-10px col-md-12 padding-left-10pe padding-right-19pe">
                  <div>
                    <label class="margin-bottom-0px">DOC</label>

                  </div>
                  <div class="margin-top-10 border-top-light2">
                    <h4 class="margin-top-10 font-size-16px font-weight-bold color-Assign">5</h4>

                  </div>
                </div>
              </div>-->
            </div>
            <div class="col-md-9 padding-left-0px">
              <form class="form " novalidate="" (ngSubmit)="onSubmitFolicular()" #f="ngForm">
                <div class="card margin-top-10">
                  <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-top-0px padding-bottom-0px">
                    <div class="row margin-left-auto">
                      <div class="col-md-7 padding-right-0px">
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-4 text-align-right padding-left-0px">
                                <label for="firstName" class="margin-bottom-0px margin-top-5px"><span>*</span>Activity For</label>
                              </div>
                              <div class="col-md-5">
                                <CodeTypeValue CodeType="IVFRC" (ngModelChange)="onChange2($event)" id="CurrentSaveTestMedCycleActivitiesRequest.ActivityType"
                                               [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" SelectedValue=""
                                               name="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" required #Activity="ngModel">

                                </CodeTypeValue>
                                <!--<CodeTypeValue CodeType="IVFAC" id="CurrentSaveTestMedCycleActivitiesRequest.ActivityType"
                                 [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" SelectedValue=""
                                 name="CurrentSaveTestMedCycleActivitiesRequest.ActivityType" required>
                  </CodeTypeValue>-->
                                <!--<input type="text" class="form-control" placeholder="Test"
                         id="CurrentSaveIvfCycleMedicineDataRequest.Form"
                         [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form"
                         name="CurrentSaveIvfCycleMedicineDataRequest.Form" #Doctor="ngModel"
                         maxlength="100" required>
                  <small class="form-text text-danger"
                         *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                  <small class="form-text text-danger"
                         *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->
                                <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                                           id="CurrentSaveIvfCycleMedicineDataRequest.Form" SelectedValue=""
                                           [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form" (keyChange)="onAssignedToActorCode($event)"
                                           name="CurrentSaveIvfCycleMedicineDataRequest.Form" required>
                  </CustomDataByRequestType>-->
                              </div>

                            </div>

                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-4 text-align-right padding-left-0px">
                                <label for="firstName" class="margin-bottom-0px margin-top-5px"><span>*</span>Day(&amp; Date)</label>
                              </div>
                              <div class="col-md-4">
                                <select class="form-control" (change)="onChange($event.target.value)">
                                  <option selected="selected" value=""></option>
                                  <option *ngFor="let l of CurrentDSAActivityByCycleCodeController">
                                    {{l.DSA}}
                                  </option>
                                </select>

                              </div>
                              <div class="col-md-4 padding-left-0px" *ngIf="ActivityDate">

                                <label class="margin-bottom-0px margin-top-7px"> ({{ActivityDate | date:'MMM-dd-yyyy'}})</label>
                              </div>
                            </div>

                          </div>
                        </div>
                        <!--<div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
              <div class="row">
                <div class="col-md-3 text-align-right margin-tg-auto ">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Date</label>
                </div>


                <div class="col-md-4" *ngIf="ActivityDate">

                  <label class="margin-bottom-0px margin-top-3px"> {{ActivityDate | date:'MMM-dd-yyyy'}}</label>
                </div>


              </div>


            </div>
          </div>-->
                        <!--<div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
              <div class="row">
                <div class="col-md-3 text-align-right">
                  <label for="firstName" class="margin-bottom-0px margin-top-5px"><span>*</span>Test Name</label>
                </div>
                <div class="col-md-5 padding-right-8px">



                  <CustomDataByRequestType RequestedType="IvfFolScanDayTests" ActorCode={{ActorCode}} (keyChange)="onAssignedToActorCode($event)"
                                           id="CurrentSaveTestMedCycleActivitiesRequest.TestCode" SelectedValue=""
                                           [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.TestCode"
                                           name="CurrentSaveTestMedCycleActivitiesRequest.TestCode" required #Test="ngModel">
                  </CustomDataByRequestType>

                </div>

              </div>

            </div>
          </div>-->

                        <div class="row margin-top-3px">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-4 text-align-right ">
                                <label for="diaplayName">Comments </label>
                              </div>
                              <div class="col-md-6 padding-right-8px ">
                                <!--<CodeTypeValue CodeType="MARTL"></CodeTypeValue>-->

                                <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Comments"
                                          name="CurrentSaveTestMedCycleActivitiesRequest.Remarks"
                                          [(ngModel)]="CurrentSaveTestMedCycleActivitiesRequest.Remarks" required minlength="1" maxlength="100"
                                          #addconcerns_text="ngModel"></textarea>
                                <small class="form-text text-danger"
                                       *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>
                              </div>
                            </div>


                          </div>
                        </div>




                      </div>
                      <div class="col-md-5" hidden>
                        <div class="card">
                          <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px  padding-t-6px padding-left-8px padding-right-0px font-size-16px">
                            <div class="row">
                              <div class="col-md-12">
                                Select Tests
                              </div>

                            </div>
                            <div class="row margin-top-5px margin-bottom-10px margin-left-0px">
                              <div class="col-md-10 padding-left-0px">
                                <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>

                              </div>



                            </div>
                          </div>
                          <div class="card-body padding-top-0px padding-left-0px padding-right-0px padding-bottom-0px margin-left-0px">

                            <div class="chatsd product-chart-wrapper product-chat-height-200px agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                              <div class="table-component actor-table margin-bottom-0px">

                                <div class="table-responsive overflow-x-hidden overflow-y-hidden">


                                  <table class="table table-striped table2">
                                    <tbody>
                                      <tr *ngFor="let l of pdata">
                                        <td class="td-padding-2px">

                                          <div class="row margin-left-zero margin-right">
                                            <div class="col-md-2  margin-tb-auto padding-right-0px padding-left-0px">
                                              <input type="checkbox" class="width-23px height-16px margin-top-3px"
                                                     [(ngModel)]="l.IsSelected" name="check">
                                              <i class="input-helper"></i>

                                            </div>
                                            <div class="col-md-10 margin-tb-auto padding-left-0px">
                                              <label class="margin-bottom-0px color3 font-size-12px">{{l.DisplayName}}</label>

                                            </div>
                                          </div>


                                        </td>
                                      </tr>

                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>




                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer text-align-center padding-top-10 padding-bottom-10px margin-top-13pe">
                    <button type="submit" [disabled]="Activity.errors?.required" class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>
                    <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto float-right margin-right-10px" (click)="activeModal.close('Close click')">Close</button>

                  </div>
                </div>
              </form>

              
            </div>
          </div>











          <!--<div class="card-footer text-align-center">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto" (click)="activeModal.close('Close click')">Close</button>
          </div>-->


















        </div>
        <!--<div class="modal-footer">
          <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
          <button type="submit" [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>
        </div>-->

      </div>
    </div>
  </div>
</div>
